import { SWITCH_DOCTOR } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface SwitchProfileResponse {
    success: boolean;
    data: Data;
}
export interface Data {
    sess: string;
    profile: Profile;
}
export interface Profile {
    uuid: string;
    mobile: string;
    email: string;
    mn: string;
    ln: string;
    'dob-valid': boolean;
    fn: string;
    fln?: string;
    oid: string;
    pic: string;
    gen: string;
    'is-p': boolean;
    as: string;
    at: string;
    'is-d-s': boolean;
    dob: string;
    bloodgroup: string;
    'is-d': boolean;
    type: number;
}

export default (id: string, newFlow: boolean = false): Promise<SwitchProfileResponse> => {
    return fetchWithRefresh(`${SWITCH_DOCTOR}?${newFlow ? 'exp=claim' : ''}`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify({
            oid: id,
        }),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw Error('failed SWITCH_DOCTOR');
        }
    });
};
